import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-white" data-id="element-186">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="mx-auto max-w-3xl" data-id="element-188">
          <div className="text-center mb-12" data-id="element-189">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4 font-serif" data-id="element-190">
              ¿Sentís que tus pies "gritan" al final del día?
            </h2>
            <div className="h-1 w-20 bg-primary mx-auto rounded-full" data-id="element-191"></div>
          </div>

          <div className="prose prose-lg mx-auto text-gray-600 mb-12" data-id="element-192">
            <p className="mb-6" data-id="element-193">
              Ese ardor punzante en el dedo gordo no es solo cansancio.{' '}
              <strong data-id="element-194">
                Es inflamación crónica deformando tu estructura ósea segundo a
                segundo.
              </strong>
            </p>
            <p data-id="element-195">
              Seguramente ya probaste esos separadores de silicona transparente
              que se rompen a la semana. O plantillas que prometen magia pero
              solo ocupan espacio en el zapato.
            </p>
            <div className="bg-red-50 border-l-4 border-red-500 p-6 my-8 rounded-r-lg" data-id="element-196">
              <div className="flex" data-id="element-197">
                <div className="flex-shrink-0" data-id="element-198">
                  <AlertCircle className="h-6 w-6 text-red-500" data-id="element-199" />
                </div>
                <div className="ml-3" data-id="element-200">
                  <h3 className="text-lg font-medium text-red-800" data-id="element-201">
                    El problema real
                  </h3>
                  <div className="mt-2 text-red-700" data-id="element-202">
                    <p data-id="element-203">
                      Estás tratando de mover un hueso ignorando el tejido
                      inflamado que lo rodea. Para corregir un juanete, no basta
                      con empujarlo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-204">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-205">
              <h3 className="flex items-center text-lg font-semibold text-gray-900 mb-4" data-id="element-206">
                <XCircle className="h-5 w-5 text-red-500 mr-2" data-id="element-207" />
                Lo que NO funciona
              </h3>
              <ul className="space-y-3 text-gray-600" data-id="element-208">
                <li className="flex items-start" data-id="element-209">
                  <span className="mr-2" data-id="element-210">•</span>
                  Separadores de silicona baratos
                </li>
                <li className="flex items-start" data-id="element-211">
                  <span className="mr-2" data-id="element-212">•</span>
                  Plantillas genéricas de farmacia
                </li>
                <li className="flex items-start" data-id="element-213">
                  <span className="mr-2" data-id="element-214">•</span>
                  Ignorar el dolor esperando que pase
                </li>
              </ul>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100" data-id="element-215">
              <h3 className="flex items-center text-lg font-semibold text-blue-900 mb-4" data-id="element-216">
                <AlertCircle className="h-5 w-5 text-blue-500 mr-2" data-id="element-217" />
                Las consecuencias
              </h3>
              <ul className="space-y-3 text-blue-800" data-id="element-218">
                <li className="flex items-start" data-id="element-219">
                  <span className="mr-2" data-id="element-220">•</span>
                  Deformidad progresiva irreversible
                </li>
                <li className="flex items-start" data-id="element-221">
                  <span className="mr-2" data-id="element-222">•</span>
                  Dolor crónico al caminar ("fuego")
                </li>
                <li className="flex items-start" data-id="element-223">
                  <span className="mr-2" data-id="element-224">•</span>
                  Cirugía costosa y dolorosa
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}